import {createSlice} from '@reduxjs/toolkit'

import {
  isIframeReady,
  postMessageToChild
} from '../../infra/utils/postMessageToIFrame'

export const initialState = {
  error: '',
  success: '',
  isLoading: true,
  isTokenValidated: false,
  data: {
    ready: false,
    currencies: [],
    orderStatus: [],
    paymentConditions: [],
    deliveryLocations: [],
    shippingConditions: [],
    clients: [],
    paymentMethods: [],
    countries: [],
    services: [],
    productTypes: [],
    productCategories: [],
    productStyles: [],
    productCharacteristics: [],
    productTechnologies: [],
    productMeasures: [],
    productColors: [],
    productSizes: [],
    productWidths: [],
    productTaxRates: [],
    suppliers: [],
    positions: [],
    contractTypes: [],
    modulationTypes: [],
    employeeCategory: [],
    employeeStatus: [],
    employeeCostCenter: [],
    employeePosition: [],
    contactTypes: [],
    bannersType: [],
    receivingServers: [],
    users: [],
    processes: [],
    rawMaterialFamily: [],
    suppliersRawMaterial: [],
    productMeasuresUnit: [],
    arrivalTypes: [],
    departureTypes: [],
    attachmentTypes: [],
    returnReasons: [],
    warehouseTypes: [],
    backendVersion: null,
    languagesAvailable: [],
    movementTypes: [],
    allWarehouses: [],
    usersWithMovements: []
  }
}

const infoSlice = createSlice({
  name: 'info',
  initialState,
  reducers: {
    infoSuccess(state, action) {
      const newData = {
        ...state.data,
        ...action.payload
      }

      state.data = newData
      state.isLoading = false

      if (isIframeReady()) {
        postMessageToChild('infoData', newData)
      }
    },
    infoError(state, action) {
      state.error = action.payload
      state.isLoading = false
    },
    setLoading(state, action) {
      state.isLoading = action.payload
    },
    setTokenValidated(state) {
      state.isTokenValidated = true
    },
    setWarehousesAndMovementData(state, action) {
      state.data.movementTypes = action.payload.movementTypeListData
      state.data.allWarehouses = action.payload.allWarehousesData
      state.data.usersWithMovements = action.payload.usersWithMovementData
      state.isLoading = false
    }
  }
})

export const {
  infoSuccess,
  infoError,
  setLoading,
  setWarehousesAndMovementData,
  setTokenValidated
} = infoSlice.actions

export default infoSlice.reducer
